import * as React from 'react';
import { ConnectedComponent } from 'react-redux';
import { RouteComponentProps } from 'react-router-dom';
import * as OxyPageComponent from '../OxyPageComponent';

export class OxyPageEditor extends React.PureComponent<RouteComponentProps<{ path: string }>> {
    public render() {
        const Hack = OxyPageComponent.default as ConnectedComponent<any, any>;

        return (
            <Hack match={this.props.match} editing={true} />
        );
    }
}

export default OxyPageEditor;
